/* tslint:disable */
import {
  UserProfile,
  CheckList,
  TenantLease
} from '../index';

declare var Object: any;
export interface TenantCheckListInterface {
  "tenant_id": number;
  "check_list_id": number;
  "update_user_id": number;
  "tenant_lease_id": number;
  "status"?: boolean;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  userProfile?: UserProfile;
  check_list?: CheckList;
  update_user?: UserProfile;
  tenantLease?: TenantLease;
}

export class TenantCheckList implements TenantCheckListInterface {
  "tenant_id": number;
  "check_list_id": number;
  "update_user_id": number;
  "tenant_lease_id": number;
  "status": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  userProfile: UserProfile;
  check_list: CheckList;
  update_user: UserProfile;
  tenantLease: TenantLease;
  constructor(data?: TenantCheckListInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantCheckList`.
   */
  public static getModelName() {
    return "TenantCheckList";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TenantCheckList for dynamic purposes.
  **/
  public static factory(data: TenantCheckListInterface): TenantCheckList{
    return new TenantCheckList(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TenantCheckList',
      plural: 'TenantCheckLists',
      path: 'TenantCheckLists',
      idName: 'id',
      properties: {
        "tenant_id": {
          name: 'tenant_id',
          type: 'number'
        },
        "check_list_id": {
          name: 'check_list_id',
          type: 'number'
        },
        "update_user_id": {
          name: 'update_user_id',
          type: 'number'
        },
        "tenant_lease_id": {
          name: 'tenant_lease_id',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        userProfile: {
          name: 'userProfile',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_id',
          keyTo: 'id'
        },
        check_list: {
          name: 'check_list',
          type: 'CheckList',
          model: 'CheckList',
          relationType: 'belongsTo',
                  keyFrom: 'check_list_id',
          keyTo: 'id'
        },
        update_user: {
          name: 'update_user',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'update_user_id',
          keyTo: 'id'
        },
        tenantLease: {
          name: 'tenantLease',
          type: 'TenantLease',
          model: 'TenantLease',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'tenant_lease_id'
        },
      }
    }
  }
}
